export const trackAnalyticsEvent = (name, params = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;

  const route = window.location.hash.startsWith('#/')
    ? window.location.hash.slice(1).split('?')[0]
    : window.location.pathname;
  const pagePath = route || '/';

  try {
    window.gtag('event', name, {
      ...params,
      page_path: pagePath,
      page_location: `${window.location.origin}${pagePath}`
    });
  } catch (_) {
    // Analytics must never interrupt a customer flow.
  }
};
